import * as React from 'react';
import { Mutation } from 'react-apollo';

import gql from 'graphql-tag';

export const levelsetsResultFeedbackMutation = gql`
  mutation LevelsetsResultFeedbackMutation($responses: Object!) {
    DiagnosticFeedbackMutation(input: $responses, action: $action)
      @rest(
        type: "DiagnosticSessionsV1"
        path: "grpc/userfeedback/v1beta1/UserFeedbackAPI/CreateUserFeedback"
        method: "POST"
      ) {
      user_feedback
    }
  }
`;
type FeedbackMutationVars = {
  responses: {
    userFeedback: {
      userId: number;
      feedbackTargetId: string;
      prompt: string;
      feedback: string;
      metadata: {
        service: string;
      };
    };
  };
};

type Props = {
  userId: number;
  skillId: string;
  attemptNumber: number;
  children: (mutate: (prompt: string, feedback: string) => void) => JSX.Element;
};

const LevelSetsFeedbackDataProvider = ({ userId, skillId, attemptNumber, children }: Props) => {
  return (
    <Mutation<{}, FeedbackMutationVars> mutation={levelsetsResultFeedbackMutation}>
      {(mutateFeedback) => {
        return children((prompt, feedback) => {
          mutateFeedback({
            variables: {
              responses: {
                userFeedback: {
                  userId,
                  feedbackTargetId: `${userId}~${skillId}@${attemptNumber}`,
                  prompt,
                  feedback,
                  metadata: {
                    service: 'program-skill-objectives__levelsets_results',
                  },
                },
              },
            },
          });
        });
      }}
    </Mutation>
  );
};

export default LevelSetsFeedbackDataProvider;
